import { render, staticRenderFns } from "./AdminTableDetailRow.vue?vue&type=template&id=0356134d&"
import script from "./AdminTableDetailRow.vue?vue&type=script&lang=js&"
export * from "./AdminTableDetailRow.vue?vue&type=script&lang=js&"
import style0 from "./AdminTableDetailRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../src/web/assets/admintable/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports